import { instanceToInstance, plainToInstance } from "class-transformer";
import VueI18n from "vue-i18n";

import { VueComponent } from "../../../../../types/VueComponent";
import { BasePeriodConditionBuilder } from "../BaseCondition/BasePeriodConditionBuilder";
import { PeriodConditionsTypeEnum } from "../types";
import { DayOfWeek } from "./DayOfWeek";

export class DayOfWeekConditionBuilder extends BasePeriodConditionBuilder {
  type: PeriodConditionsTypeEnum = PeriodConditionsTypeEnum.DayOfWeek;

  view: Partial<{ setting: VueComponent; preview: VueComponent }> = {
    setting: () => import('./DayOfWeekSetting.vue')
  }

  getModel(): DayOfWeek {
    return plainToInstance(DayOfWeek, {
      type: this.type,
      values: [],
    })
  }

  prepareModel(condition?: DayOfWeek) {
    if (condition) {
      return instanceToInstance(condition)
    }

    return this.getModel()
  }
}

export const DayOfWeekBuilder = new DayOfWeekConditionBuilder()
